function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideBySideTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component";
import { StyledTwoThirdsTextAndAssetComponent } from "./two-thirds-text-and-asset-component.scss";
import DefaultProps from "./default-props";
class TwoThirdsTextAndAssetComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledTwoThirdsTextAndAssetComponent, {
            className: "two-thirds-text-and-asset-component",
            children: /*#__PURE__*/ _jsx(SideBySideTextAndAssetComponent, _object_spread({}, this.props))
        });
    }
}
export { TwoThirdsTextAndAssetComponent as default };
TwoThirdsTextAndAssetComponent.defaultProps = DefaultProps;
